import { render, staticRenderFns } from "./UserMessageInteractive.vue?vue&type=template&id=48399183"
import script from "./UserMessageInteractive.vue?vue&type=script&lang=js"
export * from "./UserMessageInteractive.vue?vue&type=script&lang=js"
import style0 from "./UserMessageInteractive.vue?vue&type=style&index=0&id=48399183&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports